/* SR-022 — "Best for" reassurance line in the Unicorn cart drawer.
 *
 * Adds a "Best for: <bike types>" line under each rack line item, plus the row-height
 * image (styles live in snippets/sr022-cart-best-for-data.liquid). Hardcode of the
 * Intelligems SR-022 win, rebuilt data-driven rather than replicating the IG DOM patch.
 *
 * HOW IT STAYS CORRECT (no stale variant lists):
 *   - DATA is server-rendered from the "Bike Types" variant metafield (custom.bike_types)
 *     into #sr022-bikefit-map. No bike-type strings in JS; the metafield is the one source.
 *   - Each drawer row IDENTIFIES ITSELF: we read its product handle (from its real
 *     <a href="/products/..">) and its shown Size value, then look the text up in the map.
 *     No /cart.js, no order/position matching — so a row can never wear another variant's
 *     list, and if the row's variant changes in place we re-apply (keyed by data-sr022-key).
 *
 * The only coupling to the app's hashed CSS-module markup is the unavoidable last mile:
 * the line row ([class*="items_details"]), its Size value ([class*="items_item_info"] dd),
 * and the append anchor (div[class*="unicorn_body_font"]). These are the same selectors
 * the winning IG version used; re-verify after any cart-app update. The hidden ProFlex
 * quick-view duplicate (#QuickViewContainer) is skipped via offsetParent.
 *
 * Assumes ProFlex's only variant option is Size, so variant.title === the Size value shown
 * in the row (matched case-insensitively as a safety net). Loaded sitewide from theme.liquid.
 */
(function () {
  'use strict';

  var MAP = null;
  function bikeMap() {
    if (MAP) return MAP;
    var el = document.getElementById('sr022-bikefit-map');
    try { MAP = el ? JSON.parse(el.textContent) : {}; } catch (e) { MAP = {}; }
    return MAP;
  }

  // The Size value shown on the row ("Narrow"/"Wide"/"Fat"), or '' for single-variant racks.
  function rowSize(det) {
    var info = det.querySelector('[class*="items_item_info"]');
    var dd = info && info.querySelector('dd');
    return dd ? dd.textContent.trim() : '';
  }

  // Product handle from the row's real product link (not the image link).
  function rowHandle(det) {
    var link = null;
    [].forEach.call(det.querySelectorAll('a[href*="/products/"]'), function (a) {
      if (!link && a.textContent.trim() && !a.querySelector('img')) link = a;
    });
    if (!link) return '';
    return ((link.getAttribute('href') || '').split('/products/')[1] || '')
      .split('?')[0].split('#')[0].split('/')[0];
  }

  function lookup(handle, size) {
    var entry = bikeMap()[handle];
    if (entry == null) return null;
    if (typeof entry === 'string') return entry;   // single-variant (Classic)
    if (!size) return null;
    if (entry[size] != null) return entry[size];   // exact Size match
    var lc = size.toLowerCase(), k;                // case-insensitive safety net
    for (k in entry) { if (entry.hasOwnProperty(k) && k.toLowerCase() === lc) return entry[k]; }
    return null;
  }

  function apply() {
    var cells = document.querySelectorAll('[class*="items_details"]');
    [].forEach.call(cells, function (det) {
      if (det.offsetParent === null) return;        // hidden ProFlex #QuickViewContainer duplicate
      var handle = rowHandle(det);
      if (!handle) return;
      var size = rowSize(det);
      var txt = lookup(handle, size);
      var key = handle + '|' + size;
      var existing = det.querySelector('.sr022-best');

      if (existing && existing.getAttribute('data-sr022-key') === key) return; // already correct
      if (!txt) { if (existing) existing.parentNode.removeChild(existing); return; }
      if (existing) { // row's variant changed in place — update rather than leave stale
        existing.setAttribute('data-sr022-key', key);
        existing.querySelector('.sr022-best__value').textContent = txt;
        return;
      }
      var anchor = det.querySelector('div[class*="unicorn_body_font"]');
      if (!anchor) return;
      var el = document.createElement('div');
      el.className = 'sr022-best';
      el.setAttribute('data-sr022-key', key);
      el.innerHTML = '<span class="sr022-best__label">Best for:</span><span class="sr022-best__value"></span>';
      el.querySelector('.sr022-best__value').textContent = txt;
      anchor.appendChild(el);
    });
  }

  var debounce = null;
  function schedule() {
    if (debounce) return;
    debounce = window.setTimeout(function () { debounce = null; apply(); }, 80);
  }

  function init() {
    apply();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
